import * as React from 'react';

export const InsiderContext = React.createContext({ isCloudInsider: false });
export const useIsCloudInsider = () => React.useContext(InsiderContext)?.isCloudInsider || false;
